// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1slhx","rootMobile":"styles_rootMobile__25Uzb"};